export const USER_STATUS = {
    UNVERIFIED: 0,
    ACTIVE: 1,
    BLOCKED: 2,
};
//# sourceMappingURL=auth.js.map